import { render, staticRenderFns } from "./TeacherStatistics.vue?vue&type=template&id=2640a72d&scoped=true"
import script from "./TeacherStatistics.vue?vue&type=script&lang=js"
export * from "./TeacherStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeacherStatistics.vue?vue&type=style&index=0&id=2640a72d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640a72d",
  null
  
)

export default component.exports